(function () {
  let rafId = null;
  let lastRun = 0;

  function clean(t) {
    return (t || "").replace(/\s+/g, " ").trim();
  }

  function debounceRun() {
    const now = Date.now();
    if (now - lastRun < 120) return;
    lastRun = now;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(buildCategoryUI);
  }

  function buildCategoryUI() {
    const drawer = document.querySelector("#facets-drawer");
    if (!drawer) return;

    // encontra o bloco cujo título é "CATEGORY"
    const headings = Array.from(
      drawer.querySelectorAll("summary, button, .accordion__toggle, .accordion__header")
    );

    let categoryBlock = null;
    for (const h of headings) {
      const txt = clean(h.textContent).toLowerCase();
      if (txt === "category") {
        categoryBlock = h.closest("details") || h.closest(".accordion") || h.parentElement;
        break;
      }
    }
    if (!categoryBlock) return;

    const inputs = Array.from(categoryBlock.querySelectorAll('input[type="checkbox"]'));
    if (!inputs.length) return;

    // remove UI antiga
    categoryBlock.querySelectorAll(".rh-cat-list").forEach((el) => el.remove());

    const wrapper = document.createElement("div");
    wrapper.className = "rh-cat-list";

    inputs.forEach((input) => {
      const id = input.id;
      const label = id ? categoryBlock.querySelector(`label[for="${CSS.escape(id)}"]`) : null;
      const labelText = clean(label ? label.textContent : "");
      if (!labelText) return;

      const item = document.createElement("button");
      item.type = "button";
      item.className = "rh-cat-item";
      if (input.checked) item.classList.add("is-active");

      item.innerHTML = `
        <span class="rh-cat-box" aria-hidden="true"></span>
        <span class="rh-cat-label"></span>
      `;
      const cleaned = labelText.replace(/\(\d+\)/g, "").trim();
item.querySelector(".rh-cat-label").textContent = cleaned;

      item.addEventListener("click", () => {
        // ✅ Multi-select: alterna apenas este
        const next = !input.checked;
        input.checked = next;

        // UI
        item.classList.toggle("is-active", next);

        // Trigger change (Prestige AJAX)
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      wrapper.appendChild(item);

      // esconde o input/label originais (mantém no DOM)
      input.style.display = "none";
      if (label) label.style.display = "none";
    });

    // insere UI no topo do bloco
    const insertPoint = categoryBlock.querySelector(".accordion__content") || categoryBlock;
    insertPoint.prepend(wrapper);
  }

  function observeDrawerOnly() {
    const drawer = document.querySelector("#facets-drawer");
    if (!drawer) return;

    const obs = new MutationObserver(debounceRun);
    obs.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    debounceRun();
    observeDrawerOnly();
  });

  window.addEventListener("load", debounceRun);

  // quando abres o drawer
  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[aria-controls="facets-drawer"]');
    if (!btn) return;
    debounceRun();
    setTimeout(debounceRun, 150);
    setTimeout(debounceRun, 400);
  });
})();